.a4{width:100%;}